import { SlaConfiguration } from "~/pages/security-model/SlaConfiguration";

const SlasEntryPage = () => {
  return <SlaConfiguration />;
};

export default SlasEntryPage;
